import { AddOn, Article } from '../../models/Article';

export enum Type {
  PUPIL = 'pupil',
  CARETAKER = 'caretaker',
  EMPTY = '',
}

export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
  EMPTY = '',
}

export interface FormValues {
  type: Type;
  caretaker: {
    gender: Gender;
    firstName: string;
    lastNamePrefix: string;
    lastName: string;
    email: string;
    mobile: string;
  };
  pupil: {
    gender: Gender;
    firstName: string;
    lastNamePrefix: string;
    lastName: string;
    email: string;
    mobile: string;
  };
  donation: {
    target: number|string;
    amount: number|string;
  };
  address: {
    postalCode: string;
    houseNumber: number|string;
    houseNumberSuffix: string;
    street: string;
    city: string;
  };
  invoice: {
    company: string;
    contact: string;
    postalCode: string;
    houseNumber: number|string;
    houseNumberSuffix: string;
    street: string;
    city: string;
    email: string;
  };
  total: {
    amountDiscount: number|string;
    amountSubTotal: number|string;
    amountTotal: number|string;
    discountApplied: boolean;
    appliedCode: string;
  };
  couponCode: string;
  school: string;
  newsletter: boolean;
  terms: boolean;
}

export enum CheckoutOrderType {
  EXT = 'ext',
  SCHOOL = 'school',
}

export interface CheckoutStateResponse {
  orderType: CheckoutOrderType;
  cartList: (Article|CartListTraining)[];
  donation: {
    tooltip: string;
    description: string;
    items: Article[];
  };
  submenu: any[];
  isPreRegisterOnly: boolean;
  pageExtSearchResults: string;
  total: {
    amountDiscount: string;
    amountSubTotal: string;
    amountTotal: string;
    discountApplied: boolean;
    appliedCode: string;
  };
  notice: null|string;
  error: null|string|string[];
  session?: null|FormValues;
}

export interface CheckoutSubmitResponse {
  redirectTo: string;
}

export interface CartListTraining {
  datum_eind: string;
  datum_start: string;
  general_end_time: string;
  general_start_time: string;
  id_training: string;
  product_type: string;
  loc_nr: string;
  loc_stad: string;
  loc_straat: string;
  prijs: string;
  product_naam: string;
  training_dates: string;
  vak_naam: string;
  vak_niveau: string;
  subItems: AddOn[];
  upsellItems: AddOn[];
}
